const isValidApiBaseUrl = (value: string) =>
  /^https?:\/\//i.test(value) && !value.includes('$');

/**
 * Get the default API base URL based on the current window location
 * This enables remote access without configuration by using the same host as the frontend
 */
const getDefaultApiBaseUrl = (): string => {
  // In build/preview mode, use the same host as the frontend with port 8080
  if (typeof window !== 'undefined' && window.location) {
    const protocol = window.location.protocol; // http: or https:
    const hostname = window.location.hostname; // e.g., 192.168.1.100, localhost, etc.
    const apiPort = '8080';

    // Use the same hostname as the frontend, but port 8080 for the backend
    return `${protocol}//${hostname}:${apiPort}`;
  }

  // Fallback for SSR or build-time (shouldn't happen with Vite SPA)
  return 'http://localhost:8080';
};

// Get API base URL from Vite environment variable or auto-detect
export const API_BASE_URL = isValidApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '')
  ? import.meta.env.VITE_API_BASE_URL!
  : getDefaultApiBaseUrl();
